<template>
  <yv-form-search
    :formSearch="formSearch"
    :inlineSearchAction="true"
    :enableExport="false"
    @search="search"
    ref="formSearch"
  ></yv-form-search>
</template>

<script>
import YvFormSearch from "@/components/Base/YvFormSearch.vue";
import { getId, initLoader } from "@/helpers/utils";
import { service_paths } from "@/constants/Services";
import { EVENT_TYPES } from "../Event/event-utils";
import { DEFAULT_OPTION_ALL } from "@/constants";

export default {
  name: "admin-search-bar",
  components: { YvFormSearch },
  inject: ["refetchEvents"],
  data() {
    const eventTypeOpts = [
      ...DEFAULT_OPTION_ALL,
      {
        id: EVENT_TYPES.schoolEvent,
        name: this.$t("schedule.school_event")
      },
      {
        id: EVENT_TYPES.classEvent,
        name: this.$t("schedule.class_schedule")
      },
      {
        id: EVENT_TYPES.meetingEvent,
        name: this.$t("schedule.virtual_meeting")
      }
    ];
    return {
      formSearch: [
        {
          label: this.$t("schedule.filter_by_term"),
          name: "term_id",
          value: "",
          displayValue: "",
          options: [],
          type: "autocomplete",
          fields: {
            text: "name",
            value: "id"
          },
          searchKey: "name__~",
          refetchOptions: this.getTermOpts
        },
        {
          label: this.$t("schedule.filter_by_class"),
          name: "classes__id",
          value: "",
          displayValue: "",
          options: [],
          type: "autocomplete",
          fields: {
            text: "name",
            value: "id"
          },
          searchKey: "name__~",
          refetchOptions: this.getClassOpts
        },
        {
          label: this.$t("schedule.filter_by_teacher"),
          name: "teacher_id",
          value: "",
          displayValue: "",
          options: [],
          type: "autocomplete",
          fields: {
            text: "name",
            value: "id"
          },
          searchKey: "username__~",
          refetchOptions: this.getTeacherOpts
        },
        {
          label: this.$t("schedule.filter_by_student"),
          name: "student_id",
          value: "",
          displayValue: "",
          options: [],
          type: "autocomplete",
          fields: {
            text: "name",
            value: "id"
          },
          searchKey: "username__~",
          refetchOptions: this.getStudentOpts
        },
        {
          label: this.$t("schedule.student_filter_event_type"),
          name: "type",
          value: "",
          options: eventTypeOpts,
          type: "select"
        }
      ]
    };
  },
  created() {
    const loader = initLoader();
    Promise.allSettled([
      this.getTermOpts(),
      this.getClassOpts(),
      this.getTeacherOpts(),
      this.getStudentOpts()
    ]).finally(() => {
      loader.hide();
    });
  },
  methods: {
    getEventsByQuery() {
      const query = this.$route.query;
      if (query.class_id && query.class_name) {
        this.formSearch[1].value = query.class_id;
        this.formSearch[1].displayValue = query.class_name;
        this.$router.replace({ query: {} });
      }
    },
    search() {
      this.refetchEvents();
    },
    getTermOpts(queryObj) {
      return this.$axios
        .get(
          service_paths.terms,
          queryObj,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(response => {
          let options = [];

          response.data.data.forEach(term => {
            options.push({ id: getId(term), name: term.name });
          });

          this.formSearch[0].options = options;
        });
    },

    getClassOpts(queryObj) {
      return this.$axios
        .get(
          `${service_paths.classes}`,
          queryObj,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(response => {
          let options = [];

          response.data.data.forEach(classObj => {
            options.push({ id: getId(classObj), name: classObj.name });
          });
          this.formSearch[1].options = options;
        });
    },
    getTeacherOpts(queryObj) {
      return this.$axios
        .get(
          `${service_paths.staffs}/?role_name=Teacher`,
          queryObj,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(response => {
          let options = [];

          response.data.data.forEach(teacher => {
            options.push({ id: getId(teacher), name: teacher.username });
          });

          this.formSearch[2].options = options;
        });
    },

    getStudentOpts(queryObj) {
      return this.$axios
        .get(
          `${service_paths.students}`,
          queryObj,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(response => {
          let options = [];

          response.data.data.forEach(student => {
            options.push({ id: getId(student), name: student.username });
          });

          this.formSearch[3].options = options;
        });
    },

    getQueryParams() {
      this.getEventsByQuery();
      return this.$refs.formSearch.getQueryParams();
    }
  }
};
</script>

<style lang="scss" scoped></style>
